import { Skeleton,Stack,Typography } from "@mui/material";
import { PrintTemplateType } from "../../../types/print-template/types";

export default function FooterModalDetailPrint({
  printTemplate,
  checkBrightness,
  isLoading,
}: {
  printTemplate?: PrintTemplateType | undefined,
  checkBrightness: Function,
  isLoading: boolean
}) {
  const hasFooter = Boolean(printTemplate?.footerText?.text);

  if (!isLoading && !hasFooter) return null;

  return (
    <>
      <style>{`
        @media print {
          .print-execution--next {
            break-before: page;
            page-break-before: always;
          }
          .print-execution-footer {
            display: flex !important;
            flex-direction: column !important;
            justify-content: flex-end !important;
          }
        }
      `}</style>
      <Stack className="print-execution-footer" direction='column' alignItems='stretch' justifyContent='flex-end' width='100%' sx={{ marginTop: '10px' }}>
        {isLoading
          ? < Skeleton variant="rounded" height={40} width={'100%'} />
          : <Typography textAlign='center' paddingTop={2} paddingBottom={2} width='100%'
            sx={{
              backgroundColor: printTemplate?.color,
              border: 'none',
              fontSize: `${printTemplate?.footerText?.size}px`,
              fontWeight: printTemplate?.footerText?.bold ? 'bold' : 500,
              fontStyle: printTemplate?.footerText?.italic ? 'italic' : 'normal',
              color: (!printTemplate?.color ? 'black' : printTemplate?.color && checkBrightness(printTemplate?.color) ? 'black' : 'white')
            }}
          >
            {printTemplate?.footerText?.text}
          </Typography>
        }
      </Stack>
    </>
  );
}
